import { render, staticRenderFns } from "./DpaFileListTable.vue?vue&type=template&id=addcaea6&"
import script from "./DpaFileListTable.vue?vue&type=script&lang=js&"
export * from "./DpaFileListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports